import { Box, Chip, Divider, Skeleton } from '@mui/material';
import { Button, Col, Form, InputNumber, Row, Select, Spin } from 'antd';
import comptroller from 'assets/images/comptroller_white.svg';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import DetailPageHeader from 'components/header/DetailPageHeader';
import InputLabel from 'components/InputLabel/index';
import MainCard from 'components/MainCard';
import { toastConfig } from 'config';
import { isEmpty } from 'lodash';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { filterChildOptionLabel } from 'pages/globals/global';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetQueryV3Mutation } from 'store/features/api/graphSlice';
import { useGetLynFormDataMutation } from 'store/features/comptroller/comptrollerApi';
import {
	useGetControlQuestionnaireByIdMutation,
	useGetLynFormPropertyMutation,
	useGetSingleIdentityMutation,
} from 'store/features/process/processApi';

export const assurerAndControlOwnerOptions = [
	{ key: 1, label: 'Position', value: 'DATA_positionList' },
	{ key: 2, label: 'Process Role', value: 'DATA_processRoleList' },
	{ key: 3, label: 'PGR', value: 'DATA_PGRList' },
];

function Create() {
	const [form] = Form.useForm();

	const { state } = useLocation();
	const navigate = useNavigate();
	const { creatorOrganizationId: companyCode } = useSelector((state) => state.profile.profileData);

	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState();
	const [selectedQuestionnaireData, setSelectedQuestionnaireData] = useState(null);

	const [GetSingleIdentity, { error: errorData, isSuccess: isSingleCaseSuccess, isLoading: isSingleCaseLoading, isError: isSingleCaseError }] =
		useGetSingleIdentityMutation();

	const [getQueryV3, { data: queryV3Data }] = useGetQueryV3Mutation();
	const [GetControlQuestionnaireById, { data: ControlQuestionnaire }] = useGetControlQuestionnaireByIdMutation();

	// useEffect(() => {
	// 	if (companyCode) {
	// 		const payload = {
	// 			companyCode,
	// 			fieldCodes: ['companyCode'],
	// 			fieldValues: [companyCode],
	// 			name: 'ControlQuestionnaireList',
	// 		};
	// 		getQueryV3(payload);
	// 	}
	// }, [companyCode]);

	const onSelectHandler = (controlId, obj) => {
		if (obj?.children) form.setFieldValue('controlIdLabel', obj?.children);

		const payload = {
			data: controlId,
			scriptName: 'getQuestionnaire',
			processCode: state?.processCode,
		};
		GetControlQuestionnaireById(payload);
	};

	const onDomainFilterHandler = () => {
		const domain = form.getFieldValue('DATA_controlDomain');
		const subDomain = form.getFieldValue('DATA_controlSubDomain');

		if (companyCode && domain && subDomain) {
			const payload = {
				companyCode,
				fieldCodes: ['companyCode', 'controlDomain', 'controlSubDomain'],
				fieldValues: [companyCode, domain, subDomain],
				name: 'ControlQuestionnaireList',
			};
			getQueryV3(payload);
		}
	};

	const onSubmitHandler = (payload) => {
		// console.log('payload', payload);
		setSubmitData(payload);
		setShowModal(true);
	};

	const onModalOkHandler = () => {
		GetSingleIdentity({
			operation: 'add-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: submitData,
		});
	};

	useEffect(() => {
		if (ControlQuestionnaire?.responseData) {
			const questionnaire = ControlQuestionnaire?.responseData;

			// setFieldsValue({});
			setSelectedQuestionnaireData(questionnaire);
			// {
			// 	// controlQuestion: questionnaire?.controlQuestion,
			// 	// ownerFullName: questionnaire?.ownerFullName,
			// 	// assurerFullName: questionnaire?.assurerFullName,
			// 	// frequency: questionnaire?.frequency,
			// 	// expectation: questionnaire?.expectation,
			// }
		}
	}, [ControlQuestionnaire]);

	useEffect(() => {
		if (isSingleCaseSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			navigate(-1);
		}

		if (isSingleCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isSingleCaseSuccess, isSingleCaseError, errorData]);

	useEffect(() => {
		if (isEmpty(state?.processCode)) {
			navigate(-1);
		}
	}, [state?.processCode]);

	return (
		<Box>
			<DetailPageHeader title={'Create ' + (state?.processName ?? '')} />

			<Spin spinning={isSingleCaseLoading} style={{ maxHeight: '100%' }}>
				<MainCard>
					<Form form={form} layout="vertical" onFinish={onSubmitHandler} autoComplete="off" requiredMark={false}>
						<AntdValuePreview form={form} show={false} />
						<Row gutter={[16, 0]}>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Questionnaire" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={20}>
								<Chip
									label={selectedQuestionnaireData?.controlQuestion}
									variant="outlined"
									sx={{
										width: '100%',
										justifyContent: 'start',
										fontWeight: 600,
										background: '#f2f2f2',
										borderColor: '#e2ebf7',
										marginBottom: '24px',
									}}
								/>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Domain" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect
									name="DATA_controlDomain"
									code="DATA_controlDomain"
									displayNameCode="DATA_controlDomain_label"
									onChange={onDomainFilterHandler}
								/>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Sub-Domain" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect
									name="DATA_controlSubDomain"
									code="DATA_controlSubDomain"
									displayNameCode="DATA_controlSubDomain_label"
									onChange={onDomainFilterHandler}
								/>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control ID" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<Form.Item name="controlIdLabel" noStyle />
								<Form.Item
									name="controlId"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										allowClear
										showSearch
										filterOption={filterChildOptionLabel}
										placeholder="Select from the list"
										onSelect={onSelectHandler}
										style={{ height: '32px', width: '100%', borderRadius: '4px' }}
									>
										{/* {options === null ? (
											<Skeleton variant="text" sx={{ fontSize: "1rem", marginX: 1 }} />
										  ) : (
										)} */}
										{queryV3Data?.results?.map((value, index) => (
											<Select.Option key={index} value={value?.propertyCode}>
												{value?.displayName}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Owner" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<InputLabel label={selectedQuestionnaireData?.ownerFullName} />
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Assurer" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<InputLabel label={selectedQuestionnaireData?.assurerFullName} />
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Category" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								{/* <NonDependantSelect
									name="PROPERTY_controlCategory"
									code="PROPERTY_controlCategory"
									displayNameCode="PROPERTY_controlCategory_label"
								/> */}
								<InputLabel label={selectedQuestionnaireData?.controlCategory} />
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Reporting Frequency" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<InputLabel label={selectedQuestionnaireData?.frequency} sx={{ textTransform: 'capitalize' }} />
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Expectation" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<InputLabel label={selectedQuestionnaireData?.expectation} />
							</Col>

							<Col xs={24}>
								<Divider sx={{ mb: 3 }} />
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Tester Type" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<Form.Item
									name="controlTesterIdentityType"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										showSearch
										allowClear
										style={{ width: '100%', height: '32px', borderRadius: '4px' }}
										filterOption={true}
										onChange={() => {
											form.setFieldValue('controlTesterIdentityValue');
											form.setFieldValue('controlTesterIdentityLabel');
										}}
										placeholder="Select from the list"
										optionFilterProp="children"
									>
										{assurerAndControlOwnerOptions?.map(({ key, value, label }) => (
											<Select.Option key={key} value={value}>
												{label}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Tester Value" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<Form.Item
									noStyle
									shouldUpdate={(previousValue, currentValue) =>
										previousValue?.controlTesterIdentityType !== currentValue?.controlTesterIdentityType
									}
								>
									{({ getFieldValue }) => (
										<DependantSelect
											label=" "
											name="controlTesterIdentityValue"
											displayNameCode="controlTesterIdentityLabel"
											code={getFieldValue('controlTesterIdentityType')}
											//   dependentCode="ownerIdentityType"
											isDependent={true}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									)}
								</Form.Item>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Testing Frequency" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect
									name="PROPERTY_testingFrequency"
									code="PROPERTY_testingFrequency"
									displayNameCode="PROPERTY_testingFrequency_label"
								/>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Reporting Due Date" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								{/* <CustomDateInput form={form} name="testingDueDate" /> */}
								<Form.Item
									name="testingDueDate"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<InputNumber placeholder="Write here" style={{ width: '100%' }} />
								</Form.Item>
								{/* <InputLabel label={selectedQuestionnaireData?.expectation} /> */}
							</Col>

							{/* <Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Rating Mechanism" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect
									name="PROPERTY_ratingMechanism"
									code="PROPERTY_ratingMechanism"
									displayNameCode="PROPERTY_ratingMechanism_label"
								/>
							</Col> */}

							{/* <Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Data Sets" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<Form.Item
									name="dataSets"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Input style={{ height: '32px', borderRadius: '4px' }} />
								</Form.Item>
							</Col> */}

							{/* <Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Data Owner Type" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<Form.Item
									name="dataOwnerIdentityType"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										showSearch
										allowClear
										style={{ width: '100%', height: '32px', borderRadius: '4px' }}
										filterOption={true}
										onChange={() => {
											form.setFieldValue('dataOwnerIdentityValue');
											form.setFieldValue('dataOwnerIdentityLabel');
										}}
										placeholder="Select from the list"
										optionFilterProp="children"
									>
										{assurerAndControlOwnerOptions?.map(({ key, value, label }) => (
											<Select.Option key={key} value={value}>
												{label}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Data Owner Value" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<Form.Item
									noStyle
									shouldUpdate={(previousValue, currentValue) =>
										previousValue?.dataOwnerIdentityType !== currentValue?.dataOwnerIdentityType
									}
								>
									{({ getFieldValue }) => (
										<DependantSelect
											name="dataOwnerIdentityValue"
											displayNameCode="dataOwnerIdentityLabel"
											code={getFieldValue('dataOwnerIdentityType')}
											//   dependentCode="ownerIdentityType"
											isDependent={true}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									)}
								</Form.Item>
							</Col> */}

							<Col xs={24}>
								<Button type="primary" htmlType="submit" style={{ textAlign: 'right' }}>
									Submit
								</Button>
							</Col>
						</Row>
					</Form>
				</MainCard>
			</Spin>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					modalData={{
						head: state?.processName ?? '',
						label: 'Do you want to proceed?',
					}}
					setShowModal={setShowModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</Box>
	);
}

export default Create;

export const MultiDependantSelect = ({
	name,
	displayNameCode,
	rules,
	isDependent = false,
	dependencyKeys = [],
	dependencyValues = [],
	onSelectHandlerFunc,
}) => {
	const form = Form.useFormInstance();
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);

	const [options, setOptions] = useState(isDependent ? [] : null);

	const [getQueryV3, { data: queryV3Data }] = useGetQueryV3Mutation();

	const onSelectHandler = (value, obj) => {
		if ((displayNameCode, obj?.children)) {
			form.setFieldValue(displayNameCode, obj?.children);
		}

		if (typeof onSelectHandlerFunc === 'function') onSelectHandlerFunc(value);
	};

	useEffect(() => {
		// console.log(dependencyValues);

		const isValid = dependencyKeys.every((key, index) => {
			const value = dependencyValues[index];
			return !isEmpty(value);
		});

		if (companyCode && isValid) {
			const payload = {
				companyCode,
				fieldCodes: ['companyCode', ...dependencyKeys],
				fieldValues: [companyCode, ...dependencyValues],
				name: 'ControlQuestionnaireList',
			};
			getQueryV3(payload);
		}
	}, [companyCode, ...dependencyValues]);

	useEffect(() => {
		if (queryV3Data?.results?.length > 0) {
			setOptions(queryV3Data?.results);
		} else {
			setOptions([]);
		}
	}, [queryV3Data]);

	return (
		<>
			<Form.Item name={name} rules={rules}>
				{options === null ? (
					<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
				) : (
					<Select
						allowClear
						showSearch
						// style={{ width: '100%' }}
						filterOption={filterChildOptionLabel}
						placeholder="Select from the list"
						onSelect={onSelectHandler}
						style={{ height: '32px', borderRadius: '4px', width: '100%' }}
					>
						{options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyCode}>
								{value?.displayName}
							</Select.Option>
						))}
					</Select>
				)}
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};

export const DependantSelect = ({ name, displayNameCode, code, rules, isDependent = false, processCode }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [options, setOptions] = useState(isDependent ? [] : null);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onSelectHandler = (value) => {
		if (displayNameCode) {
			const label = form.getFieldValue(value);
			form.setFieldValue(displayNameCode, label);
		}
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		} else if (code?.startsWith('DATA_')) {
			const queryName = code.replace('DATA_', '');
			GetLynFormData({
				name: queryName,
				userId,
			});
		}
	}, [code, userId]);

	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties);
			lynProperty?.lynProperties?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}

		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results);
			lynFormData?.results?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}
	}, [lynProperty, lynFormData]);

	return (
		<>
			<Form.Item name={name} rules={rules}>
				{options === null ? (
					<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
				) : (
					<Select
						allowClear
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						showSearch
						filterOption={filterChildOptionLabel}
						onSelect={onSelectHandler}
						placeholder="Select from the list"
						autoComplete="off"
					>
						{options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))}
					</Select>
				)}
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};

export const NonDependantSelect = ({ name, code, displayNameCode, processCode, onChange }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [options, setOptions] = useState(null);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onSelectHandler = (value, obj) => {
		if (obj?.children) {
			form.setFieldValue(displayNameCode, obj?.children);
		}

		if (onChange) onChange();
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		} else if (code?.startsWith('DATA_')) {
			const queryName = code.replace('DATA_', '');
			GetLynFormData({
				name: queryName,
				userId,
			});
		}
	}, [code, userId]);

	// Store options code & displayName in form.
	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties);
			lynProperty?.lynProperties?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}

		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results);
			lynFormData?.results?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}
	}, [lynProperty, lynFormData]);

	return (
		<>
			<Form.Item
				name={name}
				rules={[
					{
						required: true,
						message: 'Field is required',
					},
				]}
			>
				<Select
					allowClear
					showSearch
					style={{ width: '100%', height: '32px', borderRadius: '4px' }}
					onSelect={onSelectHandler}
					filterOption={filterChildOptionLabel}
					placeholder="Select from the list"
				>
					{options === null ? (
						<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
					) : (
						options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))
					)}
				</Select>
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};
